module.exports = __webpack_public_path__ + "img/icon_class4.743bd73a.png";